var exports = {
  "Sl": "x61f99309--65d09a--image",
  "d4": "x61f99309--65d09a--images-container",
  "dK": "x61f99309--65d09a--single-image",
  "KD": "x61f99309--65d09a--multiple-images",
  "Oz": "x61f99309--65d09a--image-placeholder",
  "iq": "x61f99309--65d09a--image-container",
  "Pu": "x61f99309--65d09a--image-reload-button",
  "OT": "x61f99309--65d09a--replay-image",
  "GH": "x61f99309--65d09a--image-replay-placeholder",
};

module.exports = exports;
